import { render, staticRenderFns } from "./CopyrightDialog.vue?vue&type=template&id=102ae2a8&scoped=true&"
import script from "./CopyrightDialog.vue?vue&type=script&lang=js&"
export * from "./CopyrightDialog.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightDialog.vue?vue&type=style&index=0&id=102ae2a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102ae2a8",
  null
  
)

export default component.exports